import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "countryName pr-2" }
const _hoisted_2 = { class: "mainText pl-0 ml0" }
const _hoisted_3 = { class: "mainText" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_movement_widget = _resolveComponent("movement-widget")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_explore_button = _resolveComponent("explore-button")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_for = _resolveComponent("v-for")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "movement-focus" }, {
    default: _withCtx(() => [
      (!_ctx.isMobile)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item, i) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: i,
                  class: _normalizeClass(i < 2 ? 'sideBorder mr-3' : 'sideBorderHidden mr-3')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "mb-0 pb-0 pl-3" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h5", _hoisted_1, _toDisplayString(item.country_name), 1),
                        _createVNode(_component_movement_widget, { countryObject: item }, null, 8, ["countryObject"]),
                        (i == _ctx.countries.length -1)
                          ? _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              class: "pl-2 movement-tooltip"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-information-outline")
                              ]),
                              _: 1
                            })), [
                              [_directive_tooltip, _ctx.tooltip]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_row, { class: "mt-0 pt-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          md: "12",
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_2, _toDisplayString(item.riskData[0].description), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_row, { class: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_explore_button, {
                              class: "",
                              onClick: ($event: any) => (_ctx.selectCountry(item))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isMobile)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_carousel, {
                modelValue: _ctx.currentPage,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                "hide-delimiters": "",
                "show-arrows-on-hover": "",
                class: "movement-focus-carousel",
                height: "345px"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item, i) => {
                    return (_openBlock(), _createBlock(_component_v_carousel_item, {
                      key: i,
                      class: "pa-0 ma-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { class: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              md: "8",
                              cols: "12",
                              class: "countryName"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("h5", null, _toDisplayString(item.country_name), 1),
                                _createVNode(_component_movement_widget, {
                                  class: "movement-widget-component ml-3",
                                  countryObject: item
                                }, null, 8, ["countryObject"]),
                                (i == _ctx.countries.length -1)
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      "open-on-click": "",
                                      width: "90%",
                                      text: _ctx.tooltip,
                                      class: "lineItem movementInfoIcon"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_img, _mergeProps({ ref_for: true }, props, {
                                          src: require('@/assets/icons/atradius-info.svg'),
                                          class: "info-icon"
                                        }), null, 16, ["src"])
                                      ]),
                                      _: 1
                                    }, 8, ["text"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_row, { class: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              md: "3",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_3, _toDisplayString(item.riskData[0].description), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_row, { class: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_explore_button, {
                                  onClick: ($event: any) => (_ctx.selectCountry(item)),
                                  class: "mobileExploreButton"
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_row, {
                justify: "center",
                class: "mt-3 ml-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "12",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            md: "8",
                            cols: "8"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_for, { class: "pagination-bars" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_v_col, {
                                      key: index,
                                      class: _normalizeClass([{ 'active-bar': index === _ctx.currentPage }, "pagination-bar"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          onClick: ($event: any) => (_ctx.goTo(index))
                                        }, null, 8, _hoisted_4)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                icon: "",
                                onClick: _ctx.prev,
                                class: "paginationArrow paginationArrowPrev",
                                variant: "text",
                                rounded: 'rounded',
                                density: "compact",
                                disabled: !_ctx.prevEnabled
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-chevron-left")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                icon: "",
                                onClick: _ctx.next,
                                class: "paginationArrow paginationArrowNext",
                                variant: "text",
                                rounded: 'rounded',
                                density: "compact",
                                disabled: !_ctx.nextEnabled
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-chevron-right")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}